// Formatting utilities — ported from vanilla fmt(), pct(), initials(), fmt$ helpers.

/** Format a dollar amount — e.g. 12345.6 → "$12,346" */
export function fmt(n: number | null | undefined): string {
  if (n == null || isNaN(n)) return '$0'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n)
}

/** Format a dollar amount with cents — e.g. 12345.6 → "$12,345.60" */
export function fmtCents(n: number | null | undefined): string {
  if (n == null || isNaN(n)) return '$0.00'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n)
}

/** Safe percentage — e.g. pct(50, 200) → 25 */
export function pct(numerator: number, denominator: number): number {
  if (!denominator) return 0
  return Math.round((numerator / denominator) * 100)
}

/** Initials from a name — "John Smith" → "JS", "Acme Corp" → "AC" */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0] ?? '')
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

/** Format an ISO date string to locale format — "2024-01-15" → "Jan 15, 2024" */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso + 'T00:00:00')
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

/** Get today as YYYY-MM-DD */
export function today(): string {
  return new Date().toISOString().split('T')[0]!
}
